// store.js

import Vue from 'vue';
import Vuex from 'vuex';
import moment from "moment";
Vue.use(Vuex);

export default new Vuex.Store({
    // 在这里定义你的 Vuex 配置

    state: {
        hotelinfro: null, // 初始状态为 null
        isshowcen: true, // 初始状态为 null
        hotelnames: null, // 初始状态为 null
        hotelphone: '', // 初始状态为 null
        checkInDateDefult: moment(new Date()).format("YYYY-MM-DD"), // 初始状态为 null
        checkOutDateDefult: moment(new Date(new Date().getTime() + 86400000)).format("YYYY-MM-DD"),// 初始状态为 null
        selectedPlans:null // 存储选定的房间计划
    },
    mutations: {
        updateIsShowCen(state, newValue) {
            state.isshowcen = newValue;
          },
        updateId(state, hotelinfro) {
            state.hotelinfro = hotelinfro;
        }, setCheckInDateDefult(state, checkInDate) {
            state.checkInDateDefult = checkInDate;
        },
        setCheckOutDateDefult(state, checkOutDate) {
            state.checkOutDateDefult = checkOutDate;
        }, addSelectedPlan(state, plan) {
            state.selectedPlans = plan;  // 将选定的房间计划添加到 selectedPlans 数组中
        },
        clearSelectedPlans(state) {
            state.selectedPlans = []; // 清空选定的房间计划数组
        },
        setHotelPhone(state, phone) {
            state.hotelphone = phone;
          },  SET_HOTEL_NAME(state, hotelname) {
            state.hotelnames = hotelname;
          }

    },
    // 其他配置

    actions: {
        // actions
        updateHotelName({ commit }, hotelname) {
            commit('SET_HOTEL_NAME', hotelname);
          },
    },
    getters: {
        getHotelInfo(state) {
            // 从 Vuex Store 中获取 hotelinfro
            let hotelInfo = state.hotelinfro;

            // 如果 Vuex Store 中的 hotelinfro 不存在或为 null，则从缓存的 localStorage 中获取
            if (!hotelInfo) {
                const cachedHotelInfo = localStorage.getItem("hoteldata");
                hotelInfo = cachedHotelInfo ? JSON.parse(cachedHotelInfo) : null;
            }

            return hotelInfo;
        }
    }
});